import React, { memo } from 'react';

import InputFieldUpdatedOnBlur from 'js/components/UI-Elements/InputFieldUpdatedOnBlur/InputFieldUpdatedOnBlur';

import style from 'js/components/Prescription/DraggableIntervals/ValueDisplayBoxes/ValueDisplayBoxes.module.less';
import Box from '@mui/material/Box';
import { PRESCRIPTION_UNIT } from 'js/constants/PrescriptionConstants';
import NumberUtils from 'js/helpers/NumberUtils';
import { usePrescriptionJob } from 'js/components/Prescription/PrescriptionJobContext';
import PropTypes from 'prop-types';
import { useLangFile } from '../../../../context/LanguageContext';
import { isSoilLayer } from '../../PrescriptionJob';
import { getEffectiveSoilValues, getIntervalDisplayBounds } from '../../PrescriptionUtils';

const ValueDisplayBoxes = ({
  onDragValue,
  onDragEnd,
  isBulkPrescription,
  appliedInitialIntervals,
  bulkPrescriptionJobs,
}) => {
  const LangFile = useLangFile();
  const { prescriptionJob } = usePrescriptionJob();
  const { intervals, maxPrescription, fieldSize, unit } = prescriptionJob;

  const isBulkMode = isBulkPrescription && !appliedInitialIntervals;
  const effectiveValues = getEffectiveSoilValues(
    prescriptionJob.values,
    prescriptionJob.layer,
    isBulkMode,
    bulkPrescriptionJobs
  );

  const soilValues = isSoilLayer(prescriptionJob.layer) ? effectiveValues : null;

  let unitString;
  switch (unit) {
    case PRESCRIPTION_UNIT.LITER:
      unitString = `${LangFile.PrescriptionSettings.unit.liters.short} / ha`;
      break;
    case PRESCRIPTION_UNIT.PIECES_M2:
      unitString = `${LangFile.PrescriptionSettings.unit.pieces.short} / m\u00B2`;
      break;
    default:
      unitString = `${LangFile.PrescriptionSettings.unit.kilogram.short} / ha`;
      break;
  }

  const maxValue = (maxPrescription / fieldSize) * 2;

  return intervals.map((interval, idx) => {
    const bounds = getIntervalDisplayBounds(intervals, idx, soilValues);
    const roundedEntry = Number(interval.prescription.toFixed(0));
    const xPos = bounds.left + bounds.width / 2;

    return (
      <Box
        key={idx}
        className={style.Wrapper}
        sx={{
          left: `${xPos}%`,
        }}
      >
        <InputFieldUpdatedOnBlur
          disabled={false}
          value={roundedEntry}
          placeholder={roundedEntry}
          onUpdate={(value) => {
            onDragValue(idx, NumberUtils.limit(Number(value), 0, maxValue));
            if (onDragEnd) {
              onDragEnd();
            }
          }}
        />
        <span className={style.Unit}>{unitString}</span>
      </Box>
    );
  });
};

ValueDisplayBoxes.propTypes = {
  onDragValue: PropTypes.func,
  onDragEnd: PropTypes.func,
};

export default memo(ValueDisplayBoxes);
